import { ThemeOptions } from '@mui/material';

export const typographyThemeOptions: ThemeOptions = {
    typography: {
        allVariants: {
            fontFeatureSettings: "'clig' off, 'liga' off",
            fontFamily: 'Inter',
        },
        body1: {
            fontSize: '16px',
            lineHeight: '150%',
            letterSpacing: ' 0.15px',
        },
        body2: {
            fontSize: '14px',
            lineHeight: '143%',
            letterSpacing: ' 0.17px',
        },
        h1: {
            fontSize: '35px',
            fontWeight: 500,
            letterSpacing: 0,
            fontFamily: 'Inter-SemiBold',
        },
        h2: {
            fontSize: '25px',
            fontWeight: 500,
            letterSpacing: 0,
            fontFamily: 'Inter-SemiBold',
        },
        h3: {
            fontSize: '20px',
            fontWeight: 300,
            letterSpacing: '-0.01px',
            fontFamily: 'Inter-SemiBold',
        },
        h4: {
            fontSize: '16px',
            fontWeight: 500,
            letterSpacing: '-0.008px',
            fontFamily: 'Inter-SemiBold',
        },
        h5: {
            fontSize: '12px',
            fontWeight: 500,
            letterSpacing: '-0.006px',
            fontFamily: 'Inter-SemiBold',
        },
        paragraphLarge: {
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '26px',
        },
        paragraphMedium: {
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '22px',
        },
        paragraphSmall: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
        },
        subtitle: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '22px',
        },
        boldLarge: {
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '22px',
        },
        boldMedium: {
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '22px',
        },
        boldSmall: {
            fontSize: '10px',
            fontWeight: 600,
            lineHeight: '22px',
        },
        smallNote: {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '26px',
        },
        button: {
            fontSize: '12px',
            fontWeight: 600,
            lineHeight: '22px',
            fontFamily: 'Inter-SemiBold',
        },
    },

    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    paragraphLarge: 'p',
                    paragraphMedium: 'p',
                    paragraphSmall: 'p',
                    subtitle: 'p',
                    boldLarge: 'b',
                    boldMedium: 'b',
                    boldSmall: 'b',
                    smallNote: 'small',
                },
            },
        },
    },
};
